export default __webpack_public_path__ + "static/media/animals.5856b6fb.png";